import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-navy text-cream py-20 px-6 relative overflow-hidden" data-id="element-163">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-164" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-navy-light/30 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-165" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-167">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold mb-8 leading-tight" data-id="element-168">
            En EE.UU., si no hay plan… <br className="hidden md:block" data-id="element-169" />
            <span className="text-gold" data-id="element-170">tu familia paga el precio</span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-cream/90 leading-relaxed" data-id="element-171">
            <p data-id="element-172">
              Una emergencia no solo duele: también desordena la vida
              financiera. Los pagos siguen llegando y, muchas veces, la familia
              no sabe qué hacer ni por dónde empezar.
            </p>
            <p className="font-medium text-white" data-id="element-173">
              Este ebook te da una base clara para que entiendas lo esencial y
              puedas actuar con más seguridad.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}